import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../shared/shared.module';
import {AppFormsModule} from '../forms/forms.module';
import {EnrollRoutingModule, routedEnrollComponents} from './enroll-routing.module';
import {EnrollAuthGuard} from './services/enroll-auth.guard';
import {CommonMainModule} from '../common-main/common-main.module';
import {EnrollModeratorSharedModule} from '../shared/enroll-moderator-shared.module';
import {EnrollUserSharedModule} from '../shared/enroll-user-shared.module';
import {PaymentFormService} from '../../common_services/payment-form.service';
import {CenterProfessionService} from '../../common_services/center-profession.service';
import {ProfessionService} from '../../common_services/profession.service';
import {EnrollCommissionDecisionService} from './services/enroll-commission-decision.service';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    CommonMainModule,
    EnrollModeratorSharedModule,
    EnrollUserSharedModule,
    AppFormsModule,
    EnrollRoutingModule
  ],
  declarations: [
    routedEnrollComponents
  ],
  providers: [
    EnrollAuthGuard,
    PaymentFormService,
    CenterProfessionService,
    ProfessionService,
    EnrollCommissionDecisionService,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class EnrollModule {
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/enroll.module.ts